// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__15w6O","cell":"ColumnAccessor_cell__AezDi","firstCellAccent":"ColumnAccessor_firstCellAccent__1qyOM"};